import React from 'react';
import './styles.scss';
import { Image as ImageAntd } from 'antd';

const Image = (props) => {
  return <ImageAntd {...props} />;
};

Image.defaultProps = {
  preview: false,
};

export default Image;
